export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4602.ee40e5f0.jpg";